module.exports = __webpack_public_path__ + "img/green_081.5309a67a.png";